import { Order } from 'shell/view-models/order';
import { paginationListToQueryStringForBatchAndEventManager } from 'system/utils/event-batch/list-object-to-query-string-batch-event';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { typesEventFormData } from './types';

export const transformDataset = (values: typesEventFormData): string => {
  const { orders, page, rowsPerPage, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    codice: {
      value: otherValues.code,
    },
    descrizione: {
      value: otherValues.description,
    },
  };

  const ordersToTransform = orders || {};
  const ordersMapped: Order = {
    codice: ordersToTransform.codice,
    descrizione: ordersToTransform.descrizione,
  };

  return `${paginationListToQueryStringForBatchAndEventManager({
    filters: transformedFilters,
    orders: ordersMapped,
    page,
    rowsPerPage,
  })}`;
};
